module.exports = __webpack_public_path__ + "img/Dantam Bridal 21b.0de2ff46.jpg";